import { BaseApolloResponse, Language } from '@customer-portal/shared/models';

export interface LanguageListModel
  extends BaseApolloResponse<LanguageListItemModel[]> {
  data: LanguageListItemModel[];
}

export interface LanguageListItemModel {
  languageId: number;
  languageCode: Language;
  languageName: string;
  nativeLanguage: string;
}
